<template>
  <div class="main">
    <Header
      :show="true"
      title="角色列表"
      left="prepage"
      right="create"
      :click-left="handleClickLeft"
      :click-right="handleClickRight"
    />
    <div style="padding-bottom: 8vh;">
      <van-notice-bar
        wrapable
        :scrollable="false"
        left-icon="info-o"
        text="角色属于用户信息元素，用于配置系统访问权限"
      />
      <el-table
        ref="table"
        :data="table.data"
        :row-key="handleRowKey"
        :expand-row-keys="expandRowKeys"
        :row-class-name="handleRowClassName"
        :cell-style="handleCellStyle"
        @row-click="handleTableRowClick"
      >
        <el-table-column
          type="expand"
          width="30px"
        >
          <template slot-scope="{row}">
            <el-form
              label-position="left"
              inline
              class="demo-table-expand"
            >
              <el-form-item label="序号">
                <span>{{ row.id }}</span>
              </el-form-item>
              <el-form-item label="名称">
                <span>{{ row.name }}</span>
              </el-form-item>
              <el-form-item label="说明">
                <span>{{ row.remark }}</span>
              </el-form-item>
              <el-form-item label="权限">
                <span
                  v-if="row.permission.length > 0"
                  style="color: #409EFF"
                  @click="handleClickDialogOpen(row)"
                >
                  查看
                </span>
                <span
                  v-else
                  style="color: #909399"
                >查看</span>
              </el-form-item>
              <el-form-item
                v-if="checkPermission([163]) || checkPermission([164])"
                label="操作"
              >
                <el-button
                  v-if="checkPermission([163])"
                  type="primary"
                  size="mini"
                  @click="handleClickUpdate(row)"
                >
                  编辑
                </el-button>
                <el-button
                  v-if="checkPermission([164])"
                  type="danger"
                  size="mini"
                  @click="handleClickDelete(row)"
                >
                  删除
                </el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="序号"
          prop="id"
          align="center"
          width="60"
        >
          <template slot-scope="{row}">
            {{ row.id }}
          </template>
        </el-table-column>
        <el-table-column
          label="名称"
          prop="time"
          align="center"
          width="120"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.name }}
          </template>
        </el-table-column>
        <el-table-column
          label="说明"
          prop="content"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="{row}">
            {{ row.remark }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-show="table.total>0"
        :total="table.total"
        background
        layout="prev, pager, next"
        :current-page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        :pager-count="table.fullWidth>380?5:3"
        style="margin: .6rem 0; text-align: center;"
        @current-change="handleClickQuery"
      />
      <div style="height: 1rem; background-color: #FFFFFF;" />

      <el-dialog
        title="永固万年青"
        :visible.sync="dialogVisiblePermission"
        :append-to-body="true"
        :show-close="true"
        :center="true"
        :modal="false"
        top="0"
        @open="handleOpenDialog"
      >
        <div slot="title">
          <van-notice-bar
            wrapable
            :scrollable="false"
            text="请选择该角色需要的权限，支持多选"
          />
        </div>
        <div style="height: calc(100vh - 0.6rem);">
          <van-collapse v-model="activeNames">
            <van-collapse-item
              v-for="(member, index) in jsonData"
              :key="index"
              :title="(index+1) + '. ' + member.category.name"
              :name="member.category.name"
            >
              <van-checkbox-group
                v-model="permissionList"
                direction="horizontal"
              >
                <van-checkbox
                  v-for="(detail, i) in member.detail"
                  :key="i"
                  :name="detail.id"
                  shape="square"
                  disabled
                >
                  {{ detail.name }}
                </van-checkbox>
              </van-checkbox-group>
            </van-collapse-item>
          </van-collapse>
          <div style="margin: 16px; margin-bottom: 50px;">
            <van-button
              round
              block
              type="info"
              @click="handleClickDialogClose"
            >
              返回
            </van-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
  import { Dialog, ImagePreview } from 'vant'
  import { showPhoneAlarm } from '@/global/function.js'
  import { parseTime } from '@/utils'
  import checkPermission from '@/utils/permission'
  import Header from '@/views/components/header/index.vue'
  import Footer from '@/views/components/footer/index.vue'
  import { permission as JsonPermission } from "@/config/permission.json"
  import { getList, deleteOne } from '@/api/role.js'

  export default {
    name: "ServiceSystemRole",
    components: {
      Header,
      Footer
    },
    inject: ['reload'],
    data() {
      return {
        dialogVisiblePermission: false,
        jsonData: JsonPermission["list"],
        activeNames: [],
        permissionList: [],
        listQuery: {
          limit: 10,
          page: 1
        },
        isLoading: false,
        table: {
          listLoading: false,
          fullWidth: document.documentElement.clientWidth,
          key: 0,
          total: 0,
          data: []
        },
        expandRowKeys: [],
        handleRowKey(row) {
          return row.id
        },
        loading: false
      }
    },
    computed: {

    },
    watch: {

    },
    beforeCreate() {

    },
    created() {
      this.handleClickQuery()
    },
    beforeMount() {

    },
    mounted() {

    },
    beforeUpdate() {

    },
    updated() {

    },
    beforeDestroy() {

    },
    destroyed() {

    },
    methods: {
      checkPermission,
      handleClickLeft() {
        this.$router.go(-1)
        // console.log('dashboard-left')
      },
      handleClickRight() {
        this.$router.push({
          path:'/service/system/role/create',
          query: {} ,
        })
      },
      handleOpenDialog() {
        for (let i=0; i<this.jsonData.length; i++) {
          this.activeNames.push(this.jsonData[i].category.name)
        }
      },
      handleClickDialogOpen(row) {
        this.permissionList = []
        for (let i=0; i<row.permission.length; i++) {
          this.permissionList.push(row.permission[i].id)
        }
        this.dialogVisiblePermission = true
      },
      handleClickDialogClose() {
        this.dialogVisiblePermission = false
      },
      handleTableRowClick(row, column, event) {
        this.$refs.table.toggleRowExpansion(row)
      },
      handleRowClassName({row, rowIndex}) {
        return 'normal-row'
      },
      handleCellStyle({ row, column, rowIndex, columnIndex }) {
        return ''
      },
      onRefresh() {
        setTimeout(() => {
          this.isLoading = false
          showPhoneAlarm(true, 'toast', null, 2000, null, '工程配置', '刷新完成')
        }, 1000)
      },
      handleClickQuery() {
        const data = {
          page: this.listQuery.page,
          limit: this.listQuery.limit
        }
        getList(data).then(response => {
          const { data } = response
          if (showPhoneAlarm(false, 'toast', null, 2000, data.code, null, data.message)) {
            this.table.total = data.data.total
            const items = data.data.items
            this.table.data = []
            for (let i=0; i<items.length; i++) {
              this.table.data.push({
                id: this.listQuery.limit * (this.listQuery.page - 1) + i + 1,
                serial: items[i].id,
                name: items[i].name,
                permission: items[i].permissionList,
                remark: items[i].remark
              })
            }
          }
        }).catch(function(error) {
          console.error(error)
        })
      },
      handleClickUpdate(row) {
        // this.$router.push({ path:'/service/system/role/update', query: row })
        let permission = []
        for (let i=0; i<row.permission.length; i++) {
            permission.push(row.permission[i].id)
        }
        this.$router.push({
          path:'/service/system/role/update',
          query: {
            serial: row.serial,
            name: row.name,
            permission: permission.join('|'),
            remark: row.remark
          },
        })
      },
      handleClickDelete(row) {
        Dialog.confirm({
          title: '确认删除角色？',
          message: '角色：' + row.name,
        }).then(() => {
          this.loading = true
          const data = {
            id: row.serial
          }
          deleteOne(data).then(response => {
            const { data } = response
            if (showPhoneAlarm(true, 'toast', null, 2000, data.code, '删除', data.message)) {
              this.loading = false
              this.table.data.splice(this.table.data.indexOf(row), 1)
            }
          }).catch(function(error) {
            console.error(error)
          })
        }).catch(() => {
          showPhoneAlarm(true, 'toast', null, 2000, 200, '删除', '取消')
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  // 系统样式修改
  ::v-deep .el-form-item__label {
    width: 20%;
    text-align: right;
    // margin-right: 20px;
  }
  ::v-deep .el-table__expanded-cell[class*=cell] {
    padding: 20px 10px;
  }
  .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 100%;
  }
  ::v-deep .van-cell__title {
    max-width: 100%;
  }
  ::v-deep .van-cell__value {
    max-width: 70%;
  }
  ::v-deep .el-table th>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-table td>.cell {
    padding-left: 5px;
    padding-right: 5px;
  }
  ::v-deep .el-dialog {
    position: fixed;
    width: 100%;
  }
  ::v-deep .el-dialog__header {
    padding: 0;
  }
  ::v-deep .el-dialog__headerbtn {
    top: 13px;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
    overflow-y: auto;
  }
  ::v-deep .van-checkbox {
    padding: 3px 0;
  }
  ::v-deep .van-checkbox--horizontal {
    padding: 4px 0;
  }
  ::v-deep .van-checkbox__icon--disabled.van-checkbox__icon--checked .van-icon {
    // color: #c8c9cc;
    color: #1989fa;
  }
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
  // 自定义样式
  .main {
    height: 100vh;
    font-size: 2vw;
    background-color: #FFFFFF;//#F7F8FA;
    overflow-x: hidden;
    // overflow-y:hidden;
    overflow-y: auto;
    // display: flex;
    // justify-content: center;
    // align-items: center;
  }
</style>
